// extracted by mini-css-extract-plugin
module.exports = {"itemList":"team_itemList_1I2_g"};